module.exports = __webpack_public_path__ + "media/images/amenities_icons/gym-dab7e1622d0fb260ba774da71111feef.svg";